import React, { useEffect, useState } from 'react';

const ManageOrders = () => {
    const [orders, setOrders] = useState([]);
    useEffect(() => {
        fetch('https://infinite-river-22082.herokuapp.com/orders')
            .then(res => res.json())
            .then(data => setOrders(data))
    }, []);

    const handleDeleteOrder = id => {
        const proceed = window.confirm('Are You Sure You Wanna Delete The Product?');
        if (proceed) {
            fetch(`https://infinite-river-22082.herokuapp.com/orders/${id}`, {
                method: 'DELETE'
            })
                .then(res => res.json())
                .then(data => {
                    if (data.deletedCount > 0) {
                        const remaining = orders.filter(order => order._id !== id);
                        setOrders(remaining);
                    }
                })
        }
    }
    return (
        <div>
            <h1 className='title text-center m-4'>All Orders 🚗</h1>
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th scope="col">User Name</th>
                        <th scope="col">Car Name</th>
                        <th scope="col">Action</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        orders.map(order => <tr>
                            <td>{order.userName}</td>
                            <td>{order.carName}</td>
                            <td><button onClick={() => handleDeleteOrder(order._id)} style={{ border: 'none', backgroundColor: 'black', color: 'white' }}>Delete ❌</button></td>
                        </tr>
                        )
                    }
                </tbody>
            </table>



        </div>
    );
};

export default ManageOrders;